export default function(ref) {
  return {
    methods: {
      focus() {
        this.$refs[ref].focus();
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/mixins/focus.js